module.exports = __webpack_public_path__ + "img/c5e4827b7e362606efdcf2dbafa268cb.7905ab5d.png";